import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowRightLong = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13.055 8.47084C13.4466 8.08016 13.6666 7.55035 13.6666 6.99793C13.6666 6.4455 13.4466 5.91569 13.055 5.52501L12.7584 5.22918L7.85354 0.333344H4.29814L9.72942 5.75001H0.333313V8.25001H9.72942L4.29814 13.6667H7.85354L12.7584 8.77084L13.055 8.47084Z",
		fill: "currentColor"
	})
});
export default SvgArrowRightLong;
